"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClaimEvent = exports.RewardsAccumulatedEvent = exports.UnstakePoolTokenEvent = exports.StakePoolTokenEvent = exports.WithdrawFromPoolEvent = exports.DepositToPoolEvent = exports.SwapEvent = exports.CommitmentEvent = exports.CommitmentCurveEvent = exports.RewardsWeightChangeEvent = exports.TotalCommitmentChangeEvent = exports.PoolEvent = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const liquiditypool_1 = require("./liquiditypool");
const reward_1 = require("./reward");
const coin_1 = require("../cosmos/base/v1beta1/coin");
exports.protobufPackage = "Switcheo.carbon.liquiditypool";
const basePoolEvent = {
    creator: "",
    type: "",
    id: long_1.default.UZERO,
    poolAddress: "",
};
exports.PoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.creator !== "") {
            writer.uint32(10).string(message.creator);
        }
        if (message.pool !== undefined) {
            liquiditypool_1.Pool.encode(message.pool, writer.uint32(18).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(26).string(message.type);
        }
        if (!message.id.isZero()) {
            writer.uint32(32).uint64(message.id);
        }
        if (message.poolAddress !== "") {
            writer.uint32(42).string(message.poolAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, basePoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.creator = reader.string();
                    break;
                case 2:
                    message.pool = liquiditypool_1.Pool.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.type = reader.string();
                    break;
                case 4:
                    message.id = reader.uint64();
                    break;
                case 5:
                    message.poolAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, basePoolEvent);
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? liquiditypool_1.Pool.fromJSON(object.pool)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromString(object.id)
                : long_1.default.UZERO;
        message.poolAddress =
            object.poolAddress !== undefined && object.poolAddress !== null
                ? String(object.poolAddress)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.creator !== undefined && (obj.creator = message.creator);
        message.pool !== undefined &&
            (obj.pool = message.pool ? liquiditypool_1.Pool.toJSON(message.pool) : undefined);
        message.type !== undefined && (obj.type = message.type);
        message.id !== undefined &&
            (obj.id = (message.id || long_1.default.UZERO).toString());
        message.poolAddress !== undefined &&
            (obj.poolAddress = message.poolAddress);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, basePoolEvent);
        message.creator = (_a = object.creator) !== null && _a !== void 0 ? _a : "";
        message.pool =
            object.pool !== undefined && object.pool !== null
                ? liquiditypool_1.Pool.fromPartial(object.pool)
                : undefined;
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        message.id =
            object.id !== undefined && object.id !== null
                ? long_1.default.fromValue(object.id)
                : long_1.default.UZERO;
        message.poolAddress = (_c = object.poolAddress) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseTotalCommitmentChangeEvent = {
    poolId: long_1.default.UZERO,
    totalCommitment: "",
};
exports.TotalCommitmentChangeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.totalCommitment !== "") {
            writer.uint32(18).string(message.totalCommitment);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseTotalCommitmentChangeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.totalCommitment = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseTotalCommitmentChangeEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.totalCommitment =
            object.totalCommitment !== undefined && object.totalCommitment !== null
                ? String(object.totalCommitment)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.totalCommitment !== undefined &&
            (obj.totalCommitment = message.totalCommitment);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseTotalCommitmentChangeEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.totalCommitment = (_a = object.totalCommitment) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseRewardsWeightChangeEvent = {
    poolId: long_1.default.UZERO,
    rewardsWeight: "",
};
exports.RewardsWeightChangeEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.rewardsWeight !== "") {
            writer.uint32(18).string(message.rewardsWeight);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardsWeightChangeEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.rewardsWeight = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRewardsWeightChangeEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.rewardsWeight =
            object.rewardsWeight !== undefined && object.rewardsWeight !== null
                ? String(object.rewardsWeight)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.rewardsWeight !== undefined &&
            (obj.rewardsWeight = message.rewardsWeight);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseRewardsWeightChangeEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.rewardsWeight = (_a = object.rewardsWeight) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseCommitmentCurveEvent = {};
exports.CommitmentCurveEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.commitmentCurve !== undefined) {
            reward_1.CommitmentCurve.encode(message.commitmentCurve, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCommitmentCurveEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.commitmentCurve = reward_1.CommitmentCurve.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCommitmentCurveEvent);
        message.commitmentCurve =
            object.commitmentCurve !== undefined && object.commitmentCurve !== null
                ? reward_1.CommitmentCurve.fromJSON(object.commitmentCurve)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.commitmentCurve !== undefined &&
            (obj.commitmentCurve = message.commitmentCurve
                ? reward_1.CommitmentCurve.toJSON(message.commitmentCurve)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseCommitmentCurveEvent);
        message.commitmentCurve =
            object.commitmentCurve !== undefined && object.commitmentCurve !== null
                ? reward_1.CommitmentCurve.fromPartial(object.commitmentCurve)
                : undefined;
        return message;
    },
};
const baseCommitmentEvent = {
    poolId: long_1.default.UZERO,
    address: "",
    type: "",
};
exports.CommitmentEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        if (message.commitment !== undefined) {
            reward_1.Commitment.encode(message.commitment, writer.uint32(26).fork()).ldelim();
        }
        if (message.type !== "") {
            writer.uint32(34).string(message.type);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseCommitmentEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.commitment = reward_1.Commitment.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.type = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseCommitmentEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.commitment =
            object.commitment !== undefined && object.commitment !== null
                ? reward_1.Commitment.fromJSON(object.commitment)
                : undefined;
        message.type =
            object.type !== undefined && object.type !== null
                ? String(object.type)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        message.commitment !== undefined &&
            (obj.commitment = message.commitment
                ? reward_1.Commitment.toJSON(message.commitment)
                : undefined);
        message.type !== undefined && (obj.type = message.type);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseCommitmentEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.commitment =
            object.commitment !== undefined && object.commitment !== null
                ? reward_1.Commitment.fromPartial(object.commitment)
                : undefined;
        message.type = (_b = object.type) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseSwapEvent = { poolId: long_1.default.UZERO, input: "", output: "" };
exports.SwapEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.input !== "") {
            writer.uint32(18).string(message.input);
        }
        if (message.output !== "") {
            writer.uint32(26).string(message.output);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSwapEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.input = reader.string();
                    break;
                case 3:
                    message.output = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSwapEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.input =
            object.input !== undefined && object.input !== null
                ? String(object.input)
                : "";
        message.output =
            object.output !== undefined && object.output !== null
                ? String(object.output)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.input !== undefined && (obj.input = message.input);
        message.output !== undefined && (obj.output = message.output);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseSwapEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.input = (_a = object.input) !== null && _a !== void 0 ? _a : "";
        message.output = (_b = object.output) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const baseDepositToPoolEvent = {
    poolId: long_1.default.UZERO,
    denomA: "",
    amountA: "",
    denomB: "",
    amountB: "",
    shareDenom: "",
    shareAmount: "",
    initialShareAmountBurned: long_1.default.UZERO,
    depositor: "",
};
exports.DepositToPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denomA !== "") {
            writer.uint32(18).string(message.denomA);
        }
        if (message.amountA !== "") {
            writer.uint32(26).string(message.amountA);
        }
        if (message.denomB !== "") {
            writer.uint32(34).string(message.denomB);
        }
        if (message.amountB !== "") {
            writer.uint32(42).string(message.amountB);
        }
        if (message.shareDenom !== "") {
            writer.uint32(50).string(message.shareDenom);
        }
        if (message.shareAmount !== "") {
            writer.uint32(58).string(message.shareAmount);
        }
        if (!message.initialShareAmountBurned.isZero()) {
            writer.uint32(64).uint64(message.initialShareAmountBurned);
        }
        if (message.depositor !== "") {
            writer.uint32(74).string(message.depositor);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseDepositToPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denomA = reader.string();
                    break;
                case 3:
                    message.amountA = reader.string();
                    break;
                case 4:
                    message.denomB = reader.string();
                    break;
                case 5:
                    message.amountB = reader.string();
                    break;
                case 6:
                    message.shareDenom = reader.string();
                    break;
                case 7:
                    message.shareAmount = reader.string();
                    break;
                case 8:
                    message.initialShareAmountBurned = reader.uint64();
                    break;
                case 9:
                    message.depositor = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseDepositToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denomA =
            object.denomA !== undefined && object.denomA !== null
                ? String(object.denomA)
                : "";
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.denomB =
            object.denomB !== undefined && object.denomB !== null
                ? String(object.denomB)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.shareDenom =
            object.shareDenom !== undefined && object.shareDenom !== null
                ? String(object.shareDenom)
                : "";
        message.shareAmount =
            object.shareAmount !== undefined && object.shareAmount !== null
                ? String(object.shareAmount)
                : "";
        message.initialShareAmountBurned =
            object.initialShareAmountBurned !== undefined &&
                object.initialShareAmountBurned !== null
                ? long_1.default.fromString(object.initialShareAmountBurned)
                : long_1.default.UZERO;
        message.depositor =
            object.depositor !== undefined && object.depositor !== null
                ? String(object.depositor)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denomA !== undefined && (obj.denomA = message.denomA);
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.denomB !== undefined && (obj.denomB = message.denomB);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.shareDenom !== undefined && (obj.shareDenom = message.shareDenom);
        message.shareAmount !== undefined &&
            (obj.shareAmount = message.shareAmount);
        message.initialShareAmountBurned !== undefined &&
            (obj.initialShareAmountBurned = (message.initialShareAmountBurned || long_1.default.UZERO).toString());
        message.depositor !== undefined && (obj.depositor = message.depositor);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseDepositToPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denomA = (_a = object.denomA) !== null && _a !== void 0 ? _a : "";
        message.amountA = (_b = object.amountA) !== null && _b !== void 0 ? _b : "";
        message.denomB = (_c = object.denomB) !== null && _c !== void 0 ? _c : "";
        message.amountB = (_d = object.amountB) !== null && _d !== void 0 ? _d : "";
        message.shareDenom = (_e = object.shareDenom) !== null && _e !== void 0 ? _e : "";
        message.shareAmount = (_f = object.shareAmount) !== null && _f !== void 0 ? _f : "";
        message.initialShareAmountBurned =
            object.initialShareAmountBurned !== undefined &&
                object.initialShareAmountBurned !== null
                ? long_1.default.fromValue(object.initialShareAmountBurned)
                : long_1.default.UZERO;
        message.depositor = (_g = object.depositor) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseWithdrawFromPoolEvent = {
    poolId: long_1.default.UZERO,
    denomA: "",
    amountA: "",
    denomB: "",
    amountB: "",
    shareDenom: "",
    shareAmount: "",
    withdrawer: "",
};
exports.WithdrawFromPoolEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denomA !== "") {
            writer.uint32(18).string(message.denomA);
        }
        if (message.amountA !== "") {
            writer.uint32(26).string(message.amountA);
        }
        if (message.denomB !== "") {
            writer.uint32(34).string(message.denomB);
        }
        if (message.amountB !== "") {
            writer.uint32(42).string(message.amountB);
        }
        if (message.shareDenom !== "") {
            writer.uint32(50).string(message.shareDenom);
        }
        if (message.shareAmount !== "") {
            writer.uint32(58).string(message.shareAmount);
        }
        if (message.withdrawer !== "") {
            writer.uint32(66).string(message.withdrawer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denomA = reader.string();
                    break;
                case 3:
                    message.amountA = reader.string();
                    break;
                case 4:
                    message.denomB = reader.string();
                    break;
                case 5:
                    message.amountB = reader.string();
                    break;
                case 6:
                    message.shareDenom = reader.string();
                    break;
                case 7:
                    message.shareAmount = reader.string();
                    break;
                case 8:
                    message.withdrawer = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denomA =
            object.denomA !== undefined && object.denomA !== null
                ? String(object.denomA)
                : "";
        message.amountA =
            object.amountA !== undefined && object.amountA !== null
                ? String(object.amountA)
                : "";
        message.denomB =
            object.denomB !== undefined && object.denomB !== null
                ? String(object.denomB)
                : "";
        message.amountB =
            object.amountB !== undefined && object.amountB !== null
                ? String(object.amountB)
                : "";
        message.shareDenom =
            object.shareDenom !== undefined && object.shareDenom !== null
                ? String(object.shareDenom)
                : "";
        message.shareAmount =
            object.shareAmount !== undefined && object.shareAmount !== null
                ? String(object.shareAmount)
                : "";
        message.withdrawer =
            object.withdrawer !== undefined && object.withdrawer !== null
                ? String(object.withdrawer)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denomA !== undefined && (obj.denomA = message.denomA);
        message.amountA !== undefined && (obj.amountA = message.amountA);
        message.denomB !== undefined && (obj.denomB = message.denomB);
        message.amountB !== undefined && (obj.amountB = message.amountB);
        message.shareDenom !== undefined && (obj.shareDenom = message.shareDenom);
        message.shareAmount !== undefined &&
            (obj.shareAmount = message.shareAmount);
        message.withdrawer !== undefined && (obj.withdrawer = message.withdrawer);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g;
        const message = Object.assign({}, baseWithdrawFromPoolEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denomA = (_a = object.denomA) !== null && _a !== void 0 ? _a : "";
        message.amountA = (_b = object.amountA) !== null && _b !== void 0 ? _b : "";
        message.denomB = (_c = object.denomB) !== null && _c !== void 0 ? _c : "";
        message.amountB = (_d = object.amountB) !== null && _d !== void 0 ? _d : "";
        message.shareDenom = (_e = object.shareDenom) !== null && _e !== void 0 ? _e : "";
        message.shareAmount = (_f = object.shareAmount) !== null && _f !== void 0 ? _f : "";
        message.withdrawer = (_g = object.withdrawer) !== null && _g !== void 0 ? _g : "";
        return message;
    },
};
const baseStakePoolTokenEvent = {
    poolId: long_1.default.UZERO,
    denom: "",
    amount: "",
    creator: "",
    commitmentDuration: long_1.default.UZERO,
};
exports.StakePoolTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.creator !== "") {
            writer.uint32(34).string(message.creator);
        }
        if (!message.commitmentDuration.isZero()) {
            writer.uint32(40).uint64(message.commitmentDuration);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseStakePoolTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.creator = reader.string();
                    break;
                case 5:
                    message.commitmentDuration = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseStakePoolTokenEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        message.commitmentDuration =
            object.commitmentDuration !== undefined &&
                object.commitmentDuration !== null
                ? long_1.default.fromString(object.commitmentDuration)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.creator !== undefined && (obj.creator = message.creator);
        message.commitmentDuration !== undefined &&
            (obj.commitmentDuration = (message.commitmentDuration || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseStakePoolTokenEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.creator = (_c = object.creator) !== null && _c !== void 0 ? _c : "";
        message.commitmentDuration =
            object.commitmentDuration !== undefined &&
                object.commitmentDuration !== null
                ? long_1.default.fromValue(object.commitmentDuration)
                : long_1.default.UZERO;
        return message;
    },
};
const baseUnstakePoolTokenEvent = {
    poolId: long_1.default.UZERO,
    denom: "",
    amount: "",
    creator: "",
};
exports.UnstakePoolTokenEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.denom !== "") {
            writer.uint32(18).string(message.denom);
        }
        if (message.amount !== "") {
            writer.uint32(26).string(message.amount);
        }
        if (message.creator !== "") {
            writer.uint32(34).string(message.creator);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseUnstakePoolTokenEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.denom = reader.string();
                    break;
                case 3:
                    message.amount = reader.string();
                    break;
                case 4:
                    message.creator = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseUnstakePoolTokenEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.amount =
            object.amount !== undefined && object.amount !== null
                ? String(object.amount)
                : "";
        message.creator =
            object.creator !== undefined && object.creator !== null
                ? String(object.creator)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.denom !== undefined && (obj.denom = message.denom);
        message.amount !== undefined && (obj.amount = message.amount);
        message.creator !== undefined && (obj.creator = message.creator);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseUnstakePoolTokenEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.denom = (_a = object.denom) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.creator = (_c = object.creator) !== null && _c !== void 0 ? _c : "";
        return message;
    },
};
const baseRewardsAccumulatedEvent = { poolId: long_1.default.UZERO };
exports.RewardsAccumulatedEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.accumulatedRewards !== undefined) {
            reward_1.AccumulatedRewards.encode(message.accumulatedRewards, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseRewardsAccumulatedEvent);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.accumulatedRewards = reward_1.AccumulatedRewards.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseRewardsAccumulatedEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.accumulatedRewards =
            object.accumulatedRewards !== undefined &&
                object.accumulatedRewards !== null
                ? reward_1.AccumulatedRewards.fromJSON(object.accumulatedRewards)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.accumulatedRewards !== undefined &&
            (obj.accumulatedRewards = message.accumulatedRewards
                ? reward_1.AccumulatedRewards.toJSON(message.accumulatedRewards)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseRewardsAccumulatedEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.accumulatedRewards =
            object.accumulatedRewards !== undefined &&
                object.accumulatedRewards !== null
                ? reward_1.AccumulatedRewards.fromPartial(object.accumulatedRewards)
                : undefined;
        return message;
    },
};
const baseClaimEvent = { poolId: long_1.default.UZERO, address: "" };
exports.ClaimEvent = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.poolId.isZero()) {
            writer.uint32(8).uint64(message.poolId);
        }
        if (message.address !== "") {
            writer.uint32(18).string(message.address);
        }
        for (const v of message.rewards) {
            coin_1.Coin.encode(v, writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseClaimEvent);
        message.rewards = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.poolId = reader.uint64();
                    break;
                case 2:
                    message.address = reader.string();
                    break;
                case 3:
                    message.rewards.push(coin_1.Coin.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseClaimEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromString(object.poolId)
                : long_1.default.UZERO;
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        message.rewards = ((_a = object.rewards) !== null && _a !== void 0 ? _a : []).map((e) => coin_1.Coin.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.poolId !== undefined &&
            (obj.poolId = (message.poolId || long_1.default.UZERO).toString());
        message.address !== undefined && (obj.address = message.address);
        if (message.rewards) {
            obj.rewards = message.rewards.map((e) => e ? coin_1.Coin.toJSON(e) : undefined);
        }
        else {
            obj.rewards = [];
        }
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseClaimEvent);
        message.poolId =
            object.poolId !== undefined && object.poolId !== null
                ? long_1.default.fromValue(object.poolId)
                : long_1.default.UZERO;
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        message.rewards = ((_b = object.rewards) !== null && _b !== void 0 ? _b : []).map((e) => coin_1.Coin.fromPartial(e));
        return message;
    },
};
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
